interface QuiSommesNousProps {

}

const QuiSommesNous: React.FC<QuiSommesNousProps> = () => (
  <div />
);

export default QuiSommesNous;
